// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stock-table-row {
  width: 100%;
  height: auto;
  min-height: 60px;
  display: grid;
  border-bottom: 0.7px solid #DBDBDB;
  padding: 10px 1rem;
  grid-template-columns: 5% 20% 20% 20% 20% 15%;
  place-items: center;
  position: relative;
  font-size: 0.85rem;
}
.stock-table-row > * {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 0.5rem;
}
.stock-table-row > *:nth-child(1) {
  justify-content: center;
}
.stock-table-row > *:nth-child(2) {
  justify-content: flex-start;
}
.stock-table-row > *:nth-child(3) {
  justify-content: center;
}
.stock-table-row > *:nth-child(4) {
  justify-content: center;
}
.stock-table-row > *:nth-child(5) {
  justify-content: center;
}
.stock-table-row > *:nth-child(6) {
  justify-content: center;
}
.stock-table-row__label {
  text-transform: capitalize;
  font-weight: bold;
  font-size: 0.85rem;
}

.p-chip {
  border-radius: 3px;
  font-size: 0.85rem;
  padding: 0 15px;
}

.Food {
  background-color: #FFF0E4;
  width: 30%;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.85rem;
}

.Other {
  background-color: #E4E5FF;
  width: 30%;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.85rem;
}

@media screen and (max-width: 768px) {
  .Food {
    font-size: 1.25rem;
  }
  .Other {
    font-size: 1.25rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/features/profile/components/other-table-row/other-table-row.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,kCAAA;EACA,kBAAA;EACA,6CAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AACJ;AAEI;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AAAR;AAII;EACI,uBAAA;AAFR;AAMI;EACI,2BAAA;AAJR;AAQI;EACI,uBAAA;AANR;AAUI;EACI,uBAAA;AARR;AAYI;EACI,uBAAA;AAVR;AAcI;EACI,uBAAA;AAZR;AAeI;EACI,0BAAA;EACA,iBAAA;EACA,kBAAA;AAbR;;AAiBA;EACI,kBAAA;EACA,kBAAA;EACA,eAAA;AAdJ;;AAiBA;EACI,yBAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAdJ;;AAgBA;EACI,yBAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAbJ;;AAeA;EACI;IACI,kBAAA;EAZN;EAcE;IACI,kBAAA;EAZN;AACF","sourcesContent":[".stock-table-row{\n    width: 100%;\n    height: auto;\n    min-height: 60px;\n    display: grid;\n    border-bottom: 0.7px solid #DBDBDB;\n    padding: 10px 1rem;\n    grid-template-columns: 5% 20% 20% 20% 20% 15%;\n    place-items: center;\n    position: relative;\n    font-size: 0.85rem;\n    \n    // Default alignment for all cells\n    > * {\n        width: 100%;\n        height: 100%;\n        display: flex;\n        align-items: center;\n        padding: 0 0.5rem;\n    }\n    \n    // Checkbox alignment\n    > *:nth-child(1) {\n        justify-content: center;\n    }\n    \n    // Product name alignment\n    > *:nth-child(2) {\n        justify-content: flex-start;\n    }\n    \n    // Type chip alignment\n    > *:nth-child(3) {\n        justify-content: center;\n    }\n    \n    // Total alignment\n    > *:nth-child(4) {\n        justify-content: center;\n    }\n    \n    // Pack count cell (stock count cell)\n    > *:nth-child(5) {\n        justify-content: center;\n    }\n    \n    // Pack size alignment\n    > *:nth-child(6) {\n        justify-content: center;\n    }\n    \n    &__label{\n        text-transform: capitalize;\n        font-weight: bold;\n        font-size: 0.85rem;\n    }\n}\n\n.p-chip{\n    border-radius: 3px;\n    font-size: 0.85rem;\n    padding: 0 15px;\n}\n\n.Food{\n    background-color: #FFF0E4;\n    width: 30%;\n    height: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 0.85rem;\n}\n.Other{\n    background-color: #E4E5FF;\n    width: 30%;\n    height: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;    \n    font-size: 0.85rem;\n}\n@media screen and (max-width: 768px) {\n    .Food{\n        font-size: 1.25rem;\n    }\n    .Other{\n        font-size: 1.25rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
